import colors from '@rategravity/frontend/theme/colors';
import React from 'react';
import Address from '../../components/address';
import DatePicker from '../../components/date-picker';
import { TextField } from '../../components/MaskedTextField';
import styles from '../../styles/form';
import { validateAge, validateName } from '.';

/**
 * Renders the Personal Information component for the Credit Authorization card.
 * @param model A representation of the state (see: stateContainer). It is an
 *   Immutable Map with the following keys: borrower, loan, coborrower.
 * @param onChange Function with the following parameters:
 *   @param modelKey Root-level key on the ImmutableJS model
 *            (i.e., "borrower", "loan", "coborrower")
 *   @param key Key on the second level (e.g. "creditAgree" on loan)
 *   @param val The new value for the key.
 */
export const PersonalInformation = ({ model, onChange }) => (
  <div>
    <PrimaryBorrowerPersonalInformation model={model} onChange={onChange} />

    {model.getIn(['loan', 'hasCoborrower']) ? (
      <div>
        <br />
        <br />
        <h3 style={{ color: colors.primary, fontSize: '24px', lineHeight: '1.25em' }}>
          Please provide your co-borrower&apos;s information.
        </h3>

        <CoborrowerPersonalInformation model={model} onChange={onChange} />
      </div>
    ) : null}
  </div>
);

export const PrimaryBorrowerPersonalInformation = ({ model, onChange }) => {
  const change = onChange.bind(null, 'borrower');
  const borrower = model.get('borrower');

  return (
    <div>
      <TextField
        className="private"
        value={borrower.get('name')}
        style={styles.fullWidth}
        floatingLabelText="Full Name"
        onChange={change.bind(null, 'name')}
        validate={(value) => {
          return !validateName(value) ? 'Please enter both first and last name' : '';
        }}
      />

      <DatePicker
        className="private"
        value={borrower.get('dateOfBirth')}
        onChange={(d) => change('dateOfBirth', d)}
        style={styles.fullWidth}
        validate={(d) => (!validateAge(d) ? 'You must be over 15 to use our services' : '')}
        hintText={{ month: 'Month of Birth', day: 'Day of Birth', year: 'Year of Birth' }}
        maxDate={new Date()}
      />

      {Address({ model: borrower, onChange: change, id: 'borrower' })}
    </div>
  );
};

export const CoborrowerPersonalInformation = ({ model, onChange }) => {
  const change = onChange.bind(null, 'coborrower');
  const coborrower = model.get('coborrower');

  return (
    <div>
      <TextField
        className="private"
        value={coborrower.get('name')}
        style={styles.fullWidth}
        floatingLabelText="Full Name"
        onChange={change.bind(null, 'name')}
        validate={(value) => {
          return !validateName(value) ? 'Please enter both first and last name' : '';
        }}
      />

      <br />
      {coborrower.get('cohabitate')
        ? null
        : Address({ model: coborrower, onChange: change, id: 'coborrower' })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/cards/credit-authorization/information.js